export default {

  computed: {
    production() { return (process.env.NODE_ENV === 'production'); },
  },

}